import React from "react";
import AdminOverviewCard from "./AdminOverviewCardChild";
import Account_Open from ".././../asset/images/IBA/account-open.svg";
import Total_Talktime from ".././../asset/images/IBA/total-talktime.svg";
import Conversion_Rate from ".././../asset/images/IBA/conversion.svg";
import Submitted_Accounts from ".././../asset/images/IBA/submitted-account.svg";
import Rejected_Accounts from ".././../asset/images/IBA/rejected-account.svg";
import AdminOverviewCardChild from "../IBAAdmin/AdminOverviewCardChild";

function AdminOverviewCardParent() {
  const boxData = {
    accountOpened: {
      icon: Account_Open,
      value: 2432400,
      status: "Accounts Opened",
    },
    totalTalkTime: {
      icon: Total_Talktime,
      value: 2452400,
      status: "Total TalkTime",
    },
    conversionRate: {
      icon: Conversion_Rate,
      value: 2432400,
      status: "Conversion Rate",
    },
    submittedAccounts: {
      icon: Submitted_Accounts,
      value: 24132400,
      status: "Submitted Accounts",
    },
    rejectedAccounts: {
      icon: Rejected_Accounts,
      value: 24532400,
      status: "Rejected Accounts",
    },
  };
  return (
    <>
      <div className="card-title">
        <h2 className="h2-css-all">Overview</h2>

        <select className="iba-custom-select">
          <option value="">--Select Type--</option>
          <option value="brokerage">Yesterday</option>
          <option value="mtf/las">Last week</option>
          <option value="amc">This month</option>
          <option value="brokerage"> Last month</option>
          <option value="mtf/las">Last 3 months</option>
          <option value="brokerage">Last 6 months</option>
          <option value="mtf/las">Max</option>
        </select>
      </div>
      <div className="card-contnent">
        <div className="overview-card">
          <AdminOverviewCardChild boxData={boxData.accountOpened} />
          <AdminOverviewCardChild boxData={boxData.totalTalkTime} />
          <AdminOverviewCardChild boxData={boxData.conversionRate} />
          <AdminOverviewCardChild boxData={boxData.submittedAccounts} />
          <AdminOverviewCardChild boxData={boxData.rejectedAccounts} />
        </div>
      </div>
    </>
  );
}

export default AdminOverviewCardParent;
